import styled from 'styled-components'

export const VPIconsFontFamily = 'VPTIcons'

export const Wrapper = styled.i`
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-family: ${VPIconsFontFamily} !important;
  font-size: 24px;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  line-height: 1;
  speak: never;
  text-transform: none;

  &.icon-navbar-now:before {
    content: "\\21";
  }

  &.icon-navbar-soon:before {
    content: "\\22";
  }

  &.icon-not-allowed:before {
    content: "\\24";
  }

  &.icon-arrow-right:before {
    content: "\\25";
  }

  &.icon-hme-2col:before {
    content: "\\26";
  }

  &.icon-hme-3col:before {
    content: "\\27";
  }

  &.icon-blog:before {
    content: "\\28";
  }

  &.icon-check-vin:before {
    content: "\\29";
  }

  &.icon-triman:before {
    content: "\\2a";
  }

  &.icon-label-vp:before {
    content: "\\2b";
  }

  &.icon-circle:before {
    content: "\\2c";
  }

  &.icon-sound:before {
    content: "\\2d";
  }

  &.icon-minisite:before {
    content: "\\2e";
  }

  &.icon-aboutus:before {
    content: "\\2f";
  }

  &.icon-order:before {
    content: "\\30";
  }

  &.icon-more-hme-banner:before {
    content: "\\31";
  }

  &.icon-expedition-24h:before {
    content: "\\32";
  }

  &.icon-googleplus:before {
    content: "\\33";
  }

  &.icon-share-email:before {
    content: "\\34";
  }

  &.icon-vpmobile:before {
    content: "\\35";
  }

  &.icon-mesalertes-circle:before {
    content: "\\36";
  }

  &.icon-mesalertes-circle-check:before {
    content: "\\37";
  }

  &.icon-navbar-last-time:before {
    content: "\\38";
  }

  &.icon-navbar-news:before {
    content: "\\39";
  }

  &.icon-forum:before {
    content: "\\3a";
  }

  &.icon-geoloc:before {
    content: "\\3b";
  }

  &.icon-levoyage-datedepart:before {
    content: "\\3c";
  }

  &.icon-levoyage-destination:before {
    content: "\\3d";
  }

  &.icon-levoyage-duree:before {
    content: "\\3e";
  }

  &.icon-levoyage-thematique:before {
    content: "\\3f";
  }

  &.icon-arrow-hme-banner:before {
    content: "\\40";
  }

  &.icon-volume-mid:before {
    content: "\\41";
  }

  &.icon-volume-mute:before {
    content: "\\42";
  }

  &.icon-placeholder:before {
    content: "\\43";
  }

  &.icon-access:before {
    content: "\\44";
  }

  &.icon-audio-description:before {
    content: "\\45";
  }

  &.icon-cancel-error:before {
    content: "\\46";
  }

  &.icon-captions:before {
    content: "\\47";
  }

  &.icon-chapters:before {
    content: "\\48";
  }

  &.icon-horaire:before {
    content: "\\49";
  }

  &.icon-horaire1:before {
    content: "\\4a";
  }

  &.icon-circle-inner-circle:before {
    content: "\\4b";
  }

  &.icon-circle-outline:before {
    content: "\\4c";
  }

  &.icon-cog:before {
    content: "\\4d";
  }

  &.icon-product-added:before {
    content: "\\4e";
  }

  &.icon-pinterest:before {
    content: "\\4f";
  }

  &.icon-product-added1:before {
    content: "\\50";
  }

  &.icon-back-to-top:before {
    content: "\\51";
  }

  &.icon-hd:before {
    content: "\\52";
  }

  &.icon-linkedin:before {
    content: "\\53";
  }

  &.icon-mesalertes-check:before {
    content: "\\54";
  }

  &.icon-share-email-circle:before {
    content: "\\55";
  }

  &.icon-share-video:before {
    content: "\\56";
  }

  &.icon-spinner:before {
    content: "\\57";
  }

  &.icon-square:before {
    content: "\\58";
  }

  &.icon-subtitles:before {
    content: "\\59";
  }

  &.icon-tumblr:before {
    content: "\\5a";
  }

  &.icon-replay:before {
    content: "\\5b";
  }

  &.icon-play-circle:before {
    content: "\\5c";
  }

  &.icon-specialevent:before {
    content: "\\5d";
  }

  &.icon-expedition-72h:before {
    content: "\\5e";
  }

  &.icon-mescommunications:before {
    content: "\\5f";
  }

  &.icon-quisommesnous:before {
    content: "\\60";
  }

  &.icon-mescommandes:before {
    content: "\\61";
  }

  &.icon-date:before {
    content: "\\62";
  }

  &.icon-2col:before {
    content: "\\63";
  }

  &.icon-accueil:before {
    content: "\\64";
  }

  &.icon-aide:before {
    content: "\\65";
  }

  &.icon-arrow:before {
    content: "\\66";
  }

  &.icon-close:before {
    content: "\\67";
  }

  &.icon-deconnexion:before {
    content: "\\68";
  }

  &.icon-faceback:before {
    content: "\\69";
  }

  &.icon-facebook:before {
    content: "\\6a";
  }

  &.icon-mesalertes:before {
    content: "\\6b";
  }

  &.icon-moncompte:before {
    content: "\\6c";
  }

  &.icon-panier:before {
    content: "\\6d";
  }

  &.icon-parrainage:before {
    content: "\\6e";
  }

  &.icon-twitter:before {
    content: "\\6f";
  }

  &.icon-vpcadeau:before {
    content: "\\70";
  }

  &.icon-youtube:before {
    content: "\\71";
  }

  &.icon-close-fat:before {
    content: "\\72";
  }

  &.icon-search:before {
    content: "\\73";
  }

  &.icon-arrow-left:before {
    content: "\\74";
  }

  &.icon-reinitialisation:before {
    content: "\\75";
  }

  &.icon-arrow-left2:before {
    content: "\\76";
  }

  &.icon-fullscreen-exit:before {
    content: "\\7a";
  }

  &.icon-event:before {
    content: "\\7d";
  }

  &.icon-icon_participants:before {
    content: "\\e900";
  }

  &.icon-ic_tip:before {
    content: "\\e901";
  }

  &.icon-arrow-left1:before {
    content: "\\e902";
  }

  &.icon-filter:before {
    content: "\\e903";
  }

  &.icon-ic_check:before {
    content: "\\e904";
  }

  &.icon-phone:before {
    content: "\\e905";
  }

  &.icon-more:before {
    content: "\\e906";
  }

  &.icon-hourglass:before {
    content: "\\e907";
  }

  &.icon-calendar-from:before {
    content: "\\e908";
  }

  &.icon-calendar-to:before {
    content: "\\e909";
  }

  &.icon-hourglass1:before {
    content: "\\e90a";
  }

  &.icon-passenger:before {
    content: "\\e90b";
  }

  &.icon-car:before {
    content: "\\e90c";
  }

  &.icon-pause:before {
    content: "\\e90d";
  }

  &.icon-play:before {
    content: "\\e90e";
  }

  &.icon-fullscreen:before {
    content: "\\e90f";
  }

  &.icon-volume-high:before {
    content: "\\e910";
  }

  &.icon-volume-muted:before {
    content: "\\e911";
  }

  &.icon-ic_travel_length_of_stay:before {
    content: "\\e912";
  }

  &.icon-ic_info:before {
    content: "\\e913";
  }

  &.icon-ic_travel_destination:before {
    content: "\\e914";
  }

  &.icon-ic_cross:before {
    content: "\\e915";
  }

  &.icon-pip-close:before {
    content: "\\e916";
  }

  &.icon-pip-open:before {
    content: "\\e917";
  }

  &.icon-ic_travel_date:before {
    content: "\\e918";
  }

  &.icon-ic_arrow_up:before {
    content: "\\e919";
  }

  &.icon-ic_arrow_down:before {
    content: "\\e91a";
  }

  &.icon-ic_arrow_left:before {
    content: "\\e91b";
  }

  &.icon-ic_arrow_right:before {
    content: "\\e91c";
  }
`
